import React from 'react';

const Categories = () => (
  <div className="categories">
    <h1> Under Construction </h1>
    {' '}
  </div>
);

export default Categories;
